import React from 'react';
import { useAureliaI18n } from '../../../react-hooks/useAureliaI18n';
import { formatNumber, getFieldColorStyle } from './helpers/cellFormatters';

const Number = ({ params, field }) => {
    const value = params?.value;
    const { t } = useAureliaI18n();

    if (value === null || value === '' || value === undefined) {
        return <></>;
    }

    return (
        <div
            className="text-right number-display"
            style={getFieldColorStyle(value, field)}
        >
            {formatNumber(value)}
            {field?.unit && <>{t(field.unit)}</>}
        </div>
    );
};

export default Number;
